import styles from './footer.module.css'
import Image from "next/image";
import content from "../../../language/ENGLISH.json";
import Link from "next/link";
import { useRouter } from "next/router";
import { Navigation } from 'swiper';
import { inter_Bold, inter_Regular, inter_semi_bold } from '@/components/common/Fonts';
import { Button } from 'reactstrap';

const FooterUAE = ({ setShowCertification }) => {
    const router = useRouter();
    const {
        commonAddress,
        commonEmail,
        footerContactEmail,
        footerAboutUs,
        footerCareers,
        footerContactUs,
        footerPricing,
        footerResources,
        footerCompany,
        homePageInventory,
        homePageeStore,
        homePagekhata,
        homePageCRMandLoyalty,
    } = content;

    let company = [
        { name: footerAboutUs, link: '/about-us' },
        { name: footerPricing, link: '/pricing' },
        { name: footerCareers, link: '/career' },
        { name: "Partners", link: '/' },
        { name: footerContactUs, link: '/contact-us' },
        { name: "Testimonials", link: '/testimonials' },
    ]

    let solutions = [
        // { name: 'mPOS', link: '/mPOS' },
        { name: 'Enterprise', link: '/enterprise-pos-solution' },
        { name: "All-in-One POS", link: '/all-in-one-pos-billing-software' },
        { name: "D2C POS Solutions", link: '/D2C-POS-Solutions' },
        { name: "Android POS Billing", link: '/android-pos-billing' },
        { name: "Hardware Partners", link: '/pos-hardware-partners' },
        { name: "Software Partners", link: '/pos-software-partners' },
        { name: "Payment Partners", link: '/pos-payment-partners' },

        { name: "Distributors", link: '/distributor-pos' },
        // { name: 'e-Invoice', link: '/' },
    ]

    let resources = [
        { name: 'Blog', link: 'https://blog.queuebuster.co/' },
        { name: 'Media', link: '/media' },
        { name: 'User Manual', link: '/help' },
        { name: 'Privacy Policy', link: '/privacy' },
        { name: 'Terms and Conditions', link: '/terms-and-condition' },
    ]

    let BusinessTypes = [
        { name: 'Retail', link: '/Industries/retail-pos-billing-software' },
        { name: 'Restaurants', link: '/Industries/restaurant-pos-billing-software' },
        { name: 'Grocery', link: '/Industries/grocery-pos-billing-software' },
        { name: 'Electronics', link: '/Industries/electronic-pos-billing-software' },
        { name: 'Spa & Salon', link: '/Industries/spa-and-salon-pos-billing-software' },
    ]

    let products = [
        { name: "Billing & Invoicing", link: '/features/billing-software' },
        { name: homePageInventory, link: '/features/inventory-management-software' },
        { name: homePageeStore, link: '/features/online-store' },
        { name: homePagekhata, link: '/features/khata-management-software' },
        { name: homePageCRMandLoyalty, link: '/features/customer-loyalty-program' },
        { name: "Digital Payments", link: '/features/digital-payment-software' },
        { name: "Cloud Dashboard", link: '/features/cloud-dashboard-management' },
    ]

    let socialIcons = [
        { link: "https://twitter.com/QueueBusterPOS", image: "/assets/FinalDemoHome/twitter.svg" },
        { link: "https://in.linkedin.com/company/queuebuster-pos", image: "/assets/FinalDemoHome/linkedin.svg" },
        { link: "https://www.instagram.com/queuebuster_pos/", image: "/assets/FinalDemoHome/insta.svg" },
        { link: "https://www.facebook.com/queuebuster/", image: "/assets/FinalDemoHome/facebook.svg" },
        { link: "https://www.youtube.com/channel/UC28aqzrEBKvmuDNH7CMidhg", image: "/assets/FinalDemoHome/youtube.svg" },
    ]

    return (
        <>
            <div className={styles.body}>
                <div className={styles.desktop}>
                    <div className={styles.footerContent}>

                    <div className={styles.mainDivUAE}>

                        <div
                            style={{ fontFamily: "GilroyRegular" }}
                        >
                            <div>
                                <div className={styles.footerFlexBox_UAE} >
                                    <div >
                                        <h4 style={{ fontFamily: "GilroyBold" }}> Contact us</h4>
                                        <div className={styles.contactsSection_footer}>

                                            <div style={{ display: 'flex', gap: "5rem", margin: "2rem" }} >
                                                {/* Address Section */}
                                                <div>
                                                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', fontSize: "1.5rem", fontFamily: "GilroyMedium" }}>
                                                        <div
                                                            style={{
                                                                position: 'relative',
                                                                height: '1.9rem',
                                                                width: '2rem',
                                                                marginLeft: '-3rem',
                                                            }}
                                                        >
                                                            <Image src="/assets/location_icon.svg" alt="Get POS system for UAE retail" fill />
                                                        </div>
                                                        {commonAddress}
                                                    </div>
                                                    <p>
                                                        Unit No. 401, 4th Floor, Pegasus <br />
                                                        One Tower, Plot No. A-10,<br />
                                                        Sector - 68, Noida, <br />
                                                        Uttar Pradesh-201307
                                                    </p>
                                                </div>

                                                {/* Contact Section */}
                                                <div >
                                                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', fontSize: "1.5rem", fontFamily: "GilroyMedium" }}>
                                                        <div
                                                            style={{
                                                                position: 'relative',
                                                                height: '2rem',
                                                                width: '2rem',
                                                                marginLeft: '-3rem',
                                                            }}
                                                        >
                                                            <Image src="/assets/phone_icon.svg" alt="Buy Android POS in Dubai" fill />
                                                        </div>
                                                        Contact
                                                    </div>
                                                    <p>
                                                        <span>Sales: </span>
                                                        <a href="tel:+91 78 76 180 180">+91 78 76 180 180</a>
                                                    </p>
                                                    <p>
                                                        <span>Support: </span>
                                                        <a href="tel:+91 78 61 044 000">+91 78 61 044 000</a>
                                                    </p>
                                                </div>



                                                <div>
                                                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', fontSize: "1.5rem", fontFamily: "GilroyMedium" }}>

                                                        <div
                                                            style={{
                                                                position: 'relative',
                                                                height: '1.5rem',
                                                                width: '1.5rem',
                                                                marginLeft: '-2.5rem',
                                                                bottom: "0.2rem"
                                                            }}
                                                        >
                                                            <Image src="/assets/Email_icon.svg" alt="POS software demo in UAE" fill />
                                                        </div>
                                                        {commonEmail}
                                                    </div>
                                                    <p>{footerContactEmail}</p>
                                                </div>

                                            </div>
                                            <div>
                                                {/* <div style={{margin:"0 0 4rem 0"}}>
                                                    <p>Fill in your details and our team will get you started.</p>
                                                </div> */}
                                                <div className={styles.img_container}>
                                                    <Link
                                                        href="https://play.google.com/store/apps/details?id=com.dpdtech.application.mpos"
                                                        target="_blank"
                                                    >
                                                        <div className={styles.googleplay_btn}>
                                                            <Image src="/assets/google-play.svg" alt="POS billing made easy in Dubai" fill />
                                                        </div>
                                                    </Link>
                                                    <div
                                                        className={styles.iso_img}
                                                        onClick={() => setShowCertification(true)}
                                                    >
                                                        <Image src="/assets/FinalDemoHome/iso.svg" alt="POS billing software in Dubai for retail stores" fill />
                                                    </div>
                                                    <div className={styles.aicpa_img}>
                                                        <Image src="/assets/AICPA.webp" alt="Android-based smart POS for UAE businesses" fill />
                                                    </div>
                                                </div>
                                                <div className={styles.socialMediaIconBox}>
                                                {
                                                    socialIcons?.map((ele) => {
                                                        return (
                                                            <Link
                                                                href={ele?.link}
                                                                target={"_blank"}
                                                            >
                                                                <div className={styles.icon_size}><Image src={ele?.image} alt="Offline and online POS system for Dubai merchants" fill /></div>
                                                            </Link>
                                                        )
                                                    })
                                                }
                                            </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>


                            </div>
                        </div>
                        <hr />

                        {/* --------------copyrights---------- */}
                        <div className={styles.copyrights}>
                            <div className={styles.qb_logo} onClick={() => Navigation()}><Image src='/assets/HomeLanding/QB_logo.svg' alt="Offline and online POS system for Dubai merchants" fill /></div>
                            <p className={styles.copyright_text}>
                                {`Copyright © ${new Date().getFullYear()} DPD Technologies Pvt Ltd`}
                            </p>
                            <Link href="/in-en">
                            <div style={{ display: "flex", gap: "1rem", alignItems: "center", color: "white", fontFamily:"GilroyRegular" }}>
                                <p style={{ margin: 0 }}>India</p>
                                <div style={{ position: "relative", width: "2rem", height: "2rem" }}>
                                <Image 
                                    src="/assets/HomeLanding/india-flag-icon.png" 
                                    alt="India Flag" 
                                    fill 
                                />
                                </div>
                            </div>
                            </Link>
                             
                        </div>

                    </div>
                </div >
                </div>
            </div>
        </>
    );
};



export default FooterUAE